import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaC_Van_Right: React.FC<AreaSVGProps> = ({
  fill = '#FFD91B',
  stroke = '#FFD91B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="197"
      height="112"
      viewBox="0 0 197 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_c_van_right"
          x="0"
          y="0"
          width="197"
          height="112"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_c_van_right)">
        <path
          d="M165.668 1.00293C148.5 0.947939 126.765 1.66731 104.26 3.11035C81.754 4.55349 58.5476 6.71611 38.4272 9.53613L37.9087 9.60938C19.9878 12.121 13.2654 13.0668 3.73682 16.3711L3.41943 24.6074V24.6094L3.41846 24.6338V24.6377L3.06494 32.6719C2.30108 50.3094 1.62921 67.7262 1.50146 73.9023L1.48291 74.9844V74.9863C1.34901 86.0409 1.16913 98.0889 1.01221 111H195.16V2.5C193.256 2.19167 190.676 1.90074 187.398 1.66504C181.65 1.25184 174.259 1.03045 165.668 1.00293Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
